import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '@services/authentification.service';
import {User} from '@models/user';
import {OnboardingService} from '@services/onboarding.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    isLogin = false;
    user: User;
    showHistoric = false;

    constructor(
        public authenticationService: AuthenticationService,
        public onboardingService: OnboardingService,
    ) {
    }

    ngOnInit() {
        this.isLogin = this.authenticationService.isLogin;
        this.user = this.authenticationService.currentUser;
        this.showHistoric = this.user.user_onboarding.show_historic == true || this.onboardingService.isOnboardingActivate() == false
    }
}
